// Opens a root in Lane's Lexicon in the Research rail (App listens for dawwin:lexicon-lookup).
import './laneLink.css'

export const openInLexicon=(root:string,word='')=>window.dispatchEvent(new CustomEvent('dawwin:lexicon-lookup',{detail:{root,word}}))

/** A term's head word (its first word, without vowel marks or punctuation), looked up as a word in Lane's Lexicon. */
export const headWord=(arabic:string)=>(arabic.trim().split(/\s+/)[0]||'').replace(/[\u064b-\u0652\u0670\u0640]/g,'').replace(/[^\u0621-\u064a]/g,'')
export function LaneWordLink({arabic}:{arabic:string}){
 const word=headWord(arabic)
 return word.length>=2?<button type="button" className="lane-link" title="Look this word up in Lane’s Lexicon (Research rail)" onClick={()=>openInLexicon(word,word)}>Lane’s Lexicon →</button>:null
}

export function LaneLink({root,word=''}:{root:string;word?:string}){
 return <button type="button" className="lane-link" title="Open this root in Lane’s Lexicon (Research rail)" onClick={()=>openInLexicon(root,word)}>Lane’s Lexicon →</button>
}
